const b64DecodeUnicode = str => {
  return decodeURIComponent(escape(atob(str)));
};

const read = () => {
  const state = sessionStorage["appState"];
  return state ? JSON.parse(state).auth.token : undefined;
};

const parse = token => {
  try {
    const user = JSON.parse(b64DecodeUnicode(token.split(".")[1]));
    return { token, user };
  } catch (e) {
    throw Error("Jeton de sécurité invalide");
  }
};

const parseSSOToken = token => {
  try {
    const [login, password] = b64DecodeUnicode(token).split("|");
    return { login, password };
  } catch (e) {
    throw Error("Jeton de sécurité invalide");
  }
};

export default {
  read,
  parse,
  parseSSOToken
};



// WEBPACK FOOTER //
// ./src/services/token.js